export const getErrorMessage = (error: any) => {
  return error?.response
    ? error.response.data?.message
    : error?.message || 'An error occurred';
};

export const getErrorStatusCode = (error: any) => {
  return error?.response?.status;
};
